module.exports = __webpack_public_path__ + "static/media/rentabilidade-maxi-frete.ea839f57.png";